import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { API, authHeaders } from "@/constants/roles";

const inputCls =
  "w-full rounded-2xl border border-[var(--pv-border)] bg-[var(--pv-bg)] px-4 py-2.5 text-sm font-medium text-[var(--pv-text)] placeholder:text-[var(--pv-text-4)] focus:border-cyan-400 focus:outline-none focus:ring-4 focus:ring-cyan-500/10 transition-all";

export const ChangePasswordCard = ({ testid = "change-password", title = "Change password" }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("New password must be at least 8 characters.");
      return;
    }
    if (next !== confirm) {
      toast.error("New passwords don't match.");
      return;
    }
    setBusy(true);
    try {
      await axios.post(
        `${API}/auth/change-password`,
        { current_password: current, new_password: next },
        { headers: authHeaders() }
      );
      toast.success("Password updated — use it next time you log in.");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not update password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form data-testid={testid} onSubmit={submit} className="rounded-3xl border border-[var(--pv-border)] bg-[var(--pv-card)] p-6">
      <div className="flex items-center gap-2.5">
        <KeyRound className="h-4 w-4 text-cyan-400" />
        <h3 className="font-display text-sm font-bold uppercase tracking-wider text-[var(--pv-text-3)]">{title}</h3>
      </div>
      <div className="mt-4 grid gap-3 sm:grid-cols-3">
        <input data-testid={`${testid}-current-input`} type="password" required autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.target.value)} placeholder="Current password" className={inputCls} />
        <input data-testid={`${testid}-new-input`} type="password" required minLength={8} autoComplete="new-password" value={next} onChange={(e) => setNext(e.target.value)} placeholder="New password (8+ chars)" className={inputCls} />
        <input data-testid={`${testid}-confirm-input`} type="password" required minLength={8} autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Repeat new password" className={inputCls} />
      </div>
      <button data-testid={`${testid}-submit-btn`} type="submit" disabled={busy} className="mt-4 flex items-center gap-1.5 rounded-full bg-cyan-500 px-4 py-2.5 text-xs font-bold text-white transition-colors hover:bg-cyan-600 disabled:opacity-60">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <KeyRound className="h-3.5 w-3.5" />} Update password
      </button>
    </form>
  );
};
